var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section",style:({width: _vm.widthCalc})},[_c(_vm.comp,_vm._b({tag:"component"},'component',_vm.section,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }